import { render } from "./WidgetUsuarioNovoModal.vue?vue&type=template&id=6e65eb35&scoped=true&ts=true"
import script from "./WidgetUsuarioNovoModal.vue?vue&type=script&lang=ts"
export * from "./WidgetUsuarioNovoModal.vue?vue&type=script&lang=ts"

import "./WidgetUsuarioNovoModal.vue?vue&type=style&index=0&id=6e65eb35&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e65eb35"]])

export default __exports__